import MyLocale from '@/models/MyLocale.model';

export const me = new MyLocale({
	title: 'WB-CPP',

	word: {
		to: 'do',
	},
	message: {
    emptyState: {
      noData: {
        title: 'Nema pronađenih podataka!',
        message: 'Nema pronađenih podataka!',
      },
      unknownAuthor: {
        title: 'Nepoznat autor!',
        message: 'Nepoznat autor!',
      },
    },
	},
	filters: {
		dataType: {
			title: 'Klimatski uvidi po izvoru podataka',
      info: 'Istražite posmatrane podatke i scenarije zasnovane na modelima za ključne klimatske promjenljive.',
			observation: {
				title: 'Istorijski',
			},
			scenario: {
				title: 'Scenario',
			},
      mapInfoTitle: 'Skup podataka',
		},
		variable: {
			title: 'Promjenljive',

			// Nove promjenljive
			cdd5: 'cdd5',
			cdd7: 'cdd7',
			dhi5: 'dhi5',
			dhi7: 'dhi7',
			ews: 'ews',
			ewc: 'ewc',
			ftd: 'ftd',
			hd30: 'hd30',
			hd40: 'hd40',
			ls: 'ls',
			sdii: 'sdii',
			hs: 'hs',
			sd: 'sd',
			pr: 'pr',
			tmean: 'tmean',
			tasmax: 'tasmax',
			tasmin: 'tasmin',

			// Opisi (tooltip) za nove promjenljive
			cdd5Tooltip: 'cdd5',
			cdd7Tooltip: 'cdd7',
			dhi5Tooltip: 'dhi5',
			dhi7Tooltip: 'dhi7',
			ewsTooltip: 'ews',
			ewcTooltip: 'ewc',
			ftdTooltip: 'ftd',
			hd30Tooltip: 'hd30',
			hd40Tooltip: 'hd40',
			lsTooltip: 'ls',
			sdiiTooltip: 'sdii',
			hsTooltip: 'hs',
			sdTooltip: 'sd',
			prTooltip: 'pr',
			tmeanTooltip: 'tmean',
			tasmaxTooltip: 'tasmax',
			tasminTooltip: 'tasmin',

			// Naslovi za nove promjenljive
			cdd5Title: 'Sušni periodi (5 dana)',
			cdd7Title: 'Sušni periodi (7 dana)',
			dhi5Title: 'Vrući dani tokom sušnih perioda (5 dana)',
			dhi7Title: 'Vrući dani tokom sušnih perioda (7 dana)',
			ewsTitle: 'Ekstremne brzine vetra',
			ewcTitle: 'Dani sa ekstremnim brzinama vetra',
			ftdTitle: 'Ciklusi smrzavanja i odmrzavanja',
			hd30Title: 'Vrući dani (30 °C)',
			hd40Title: 'Veoma vrući dani (40 °C)',
			lsTitle: 'Kritični uslovi padavina za klizišta',
			sdiiTitle: 'Ekstremne padavine',
			hsTitle: 'Obilne snežne padavine',
			sdTitle: 'Sneg',
			prTitle: 'Količina padavina',
			tmeanTitle: 'Srednja temperatura',
			tasmaxTitle: 'Maksimalna temperatura',
			tasminTitle: 'Minimalna temperatura',

      cdd5Description: 'Dani u uzastopnim periodima od 5 dana sa manje od 1mm padavina tokom aprila-septembra',
      cdd7Description: 'Dani u uzastopnim periodima od 7 dana sa manje od 1mm padavina tokom aprila-septembra',
      dhi5Description: 'Dani u 5-dnevnim sušnim periodima sa maksimalnom dnevnom temperaturom iznad 30°C',
      dhi7Description: 'Dani u 7-dnevnim sušnim periodima sa maksimalnom dnevnom temperaturom iznad 30°C',
      ewsDescription: '99,9. percentil dnevnih srednjih brzina vjetra u periodu posmatranja 1981-2010',
      ewcDescription: 'Dani koji prelaze 99,9. percentil dnevnih srednjih brzina vjetra u periodu posmatranja 1981-2010',
      ftdDescription: 'Dani sa minimalnom temperaturom ispod -2.2°C i maksimalnom iznad 0°C',
      hd30Description: 'Dani sa maksimalnom temperaturom iznad 30°C',
      hd40Description: 'Dani sa maksimalnom temperaturom iznad 40°C',
      lsDescription: 'Dani koji prelaze pragove intenziteta padavina prema Moser-Hohensinn metodi (M = 41.66 * (h^-0.77) * h) za h = 24, 48 i 72 sata',
      sdiiDescription: '99,9. percentil dnevnih količina padavina u periodima od 30 godina',
      hsDescription: 'Dani sa količinom padavina većom od 10mm i srednjom temperaturom ispod 0°C',
      sdDescription: 'Dani sa količinom padavina većom od 1mm i srednjom temperaturom ispod 0°C',
      prDescription: 'Dnevna količina padavina',
      tmeanDescription: 'Dnevna srednja temperatura vazduha',
      tasmaxDescription: 'Dnevna maksimalna temperatura vazduha',
      tasminDescription: 'Dnevna minimalna temperatura vazduha',

		},
		period: {
			title: 'Period',
      '1981-2010': '1981-2010',
      '2011-2040': '2011-2040',
      '2001-2020': '2001-2020',
      '2036-2065': '2036-2065',
      '2071-2100': '2071-2100',
		},
    scenario: {
      title: 'Scenario',
      ens: 'ENS',
      rcp26: 'RCP2.6 (scenario niskih emisija)',
      rcp45: 'RCP4.5 (scenario umjerenih emisija)',
      rcp85: 'RCP8.5 (scenario visokih emisija)',
    },
		season: {
			title: 'Sezona',
      'yr': 'Godišnje',
      '01': 'Januar',
      '02': 'Februar',
      '03': 'Mart',
      '04': 'April',
      '05': 'Maj',
      '06': 'Jun',
      '07': 'Jul',
      '08': 'Avgust',
      '09': 'Septembar',
      '10': 'Oktobar',
      '11': 'Novembar',
      '12': 'Decembar',
		},
		gwl: {
			title: 'Nivo globalnog zagrijavanja',
      '1.5': 'GWL1.5',
      '2.0': 'GWL2.0',
      '3.0': 'GWL3.0',
      '4.0': 'GWL4.0',
		},
		gridSpacing: {
			title: 'Razmak mreže',
      '01deg': '01deg',
		},
		author: {
      title: 'Autor',
      defaultLabel: 'Izaberite autora',
    }
	},
	options: {
		download: {
			image: 'Slika',
			pdf: 'PDF',
			file: 'Datoteka',
		},
	},
	legend: {
		min: 'min',
		max: 'maks',
	},
	mapDetails: {
		value: 'Vrijednost',

		ens: 'Medijana',
		ens75: '75. percentil',
		ens25: '25. percentil',

    noCsvData: 'Ne postoje csv podaci za ovu tačku',
    subgridToggleLabel: 'Prikaži 30arcsec mrežu',
    subgridToggleOnInfo: 'Omogućavanje 30arcsec mreže za ovu ćeliju će isto tako prikazati 30arcsec mrežu za sve ćelije koje se nalaze pored.',
    subgridToggleOffInfo: 'Izaberite ćeliju od 30\'\' da pregledate njene podatke.',
	},
	tour: {
		closeButton: 'Zatvori',
		backButton: 'Nazad',
		nextButton: 'Sljedeće',
		completeButton: 'Završi',
		startButton: 'Započni tur kroz platformu',
	},
	unit: {
		Celsius: '°C',
		'%': '%',
		mm: 'mm',
    d: 'd',
    'm s-1': 'm s-1',
	},
  mapView: {
    noneValue: 'Bez mape',
    terrain: 'Reljef',
    satellite: 'Satelit',
  },
  mapOptions: {
    showClimateData: 'Prikaži klimatske podatke',
  },
  footer: {
    kosovoBorderLabel: 'Ova odrednica je bez predrasuda prema stavovima o statusu i u skladu je sa UNSCR 1244/99.',
  },
  nav: {
    map: 'Mapa',
  },
});
